import {gql} from '@apollo/client'

export const CREATE_COMMISSION_REPORT = gql`
  mutation createCommissionReportMutation(
    $name: String!
    $effectiveMonth: Int!
    $effectiveYear: Int!
    $carrier: ID!
    $statesEU: [ID]
    $approvePreviousYear: Boolean
  ) {
    commissionReportCreateMutation(
      input: {
        name: $name
        effectiveMonth: $effectiveMonth
        effectiveYear: $effectiveYear
        carrier: $carrier
        statesEU: $statesEU
        approvePreviousYear: $approvePreviousYear
      }
    ) {
      success
      commissionReport {
        id
        name
        effectiveMonth
        effectiveYear
        carrier {
          id
          name
        }
        stateEU {
          id
          name
          code
        }
        totalApproved
        totalPending
        totalNotAssigned
        paidDate
        status
        createdBy {
          id
          firstName
          lastName
          email
        }
        created
        updated
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_COMMISSION_REPORT = gql`
  mutation updateCommissionReport($id: ID!, $input: commission_report_input!) {
    commissionReportUpdateMutation(id: $id, input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_COMMISSION_REPORT = gql`
  mutation deleteCommissionReport($id: ID!) {
    commissionReportDeleteMutation(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const HARD_DELETE_COMMISSION_REPORT = gql`
  mutation hardDeleteCommissionReport($id: ID!) {
    commissionReportHardDeleteMutation(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const UNARCHIVE_COMMISSION_REPORT = gql`
  mutation unarchiveCommissionReport($id: ID!) {
    commissionReportUnarchiveMutation(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPLOAD_PAYMENT_COMMISSION_REPORT = `
  mutation uploadPaymentCommissionReport($id: ID!, $excelFile: Upload!, $uploadType: String) {
    commissionReportUploadPaymentMutation(id: $id, excelFile: $excelFile, uploadType: $uploadType) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const UPLOAD_PAYMENT_COMMISSION_REPORT_ASYNC = `
  mutation uploadPaymentCommissionReportAsync($id: ID!, $excelFile: Upload!) {
    commissionReportUploadPaymentAsync: commissionReportUploadPaymentAsyncMutation(id: $id, excelFile: $excelFile) {
      success
      message
      task {
        taskId
        status
        progressPercentage
        progressMessage
      }
      errors {
        field
        message
      }
    }
  }
`

export const IMPORT_COMMISSION_REPORT = `
  mutation ImportCommissionReport($file: Upload!) {
    importCommissionReport: commissionReportImportFromExcelMutation(excelFile: $file) {
      success
      message
      commissionReport {
        id
        name
        totalApproved
        totalPending
        totalNotAssigned
      }
      errors {
        field
        message
      }
    }
  }
`

export const IMPORT_COMMISSION_REPORT_ASYNC = `
  mutation ImportCommissionReportAsync($file: Upload!) {
    importCommissionReportAsync: commissionReportImportFromExcelAsyncMutation(excelFile: $file) {
      success
      message
      task {
        taskId
        status
        progressPercentage
        progressMessage
      }
      errors {
        field
        message
      }
    }
  }
`

export const CALCULATE_DEDUCTIONS_COMMISSION_REPORT = gql`
  mutation calculateDeductionsCommissionReport($id: ID!) {
    commissionReportCalculateDeductionsMutation(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const CONCILIATE_BY_MEMBER_ID_COMMISSION_REPORT = gql`
  mutation conciliateByMemberIdCommissionReport($id: ID!) {
    commissionReportConciliateByMemberIdMutation(id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const CONCILIATE_BY_AGENT_COMMISSION_REPORT = gql`
  mutation conciliateByAgentCommissionReport($logIds: [ID!]!, $userId: ID!) {
    commissionReportConciliateByAgentMutation(logIds: $logIds, userId: $userId) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const TOGGLE_STATUS_COMMISSION_REPORT = gql`
  mutation toggleStatusCommissionReport($id: ID!, $newStatus: String!) {
    commissionReportToggleStatusMutation(id: $id, newStatus: $newStatus) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const SEND_PAYROLL_EMAILS = gql`
  mutation sendPayrollEmails($dateFrom: Date!, $dateTo: Date!, $userId: ID) {
    sendPayrollEmailsMutation(dateFrom: $dateFrom, dateTo: $dateTo, userId: $userId) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`
